import { Trans } from 'react-i18next';

import {
   AiAssistantBudgetSummary,
   HealthcareProviderAiAssistantTokenPackage,
} from '@dreryk/egabinet-ai-assistant-frontend-api';

import { Translate } from '@dreryk/react-common';
import { Button, StyledFlex, TextView, UsageIndicator } from '@dreryk/react-components';

import { aiAssistantSettingsPanelTranslationKeys } from '../translations';

import { findCurrentPlan, formatCurrentPlan, toTokenUsage } from './AiAssistantSettingsPanel.utils';

const BUY_TOKENS_LINK =
   'https://webforms.pipedrive.com/f/1tgignD5wLV4UYuQo3mo06EgoaKWgakTSQITuuZrzA9XF73fRSM9UsBvmwrSVt8DV';

const t = aiAssistantSettingsPanelTranslationKeys;

const openBuyTokensLink = (): void => {
   window.open(BUY_TOKENS_LINK, '_blank', 'noopener,noreferrer');
};

type AiAssistantPlanSectionProps = Readonly<{
   budgetSummary: AiAssistantBudgetSummary;
   tokenPackages: HealthcareProviderAiAssistantTokenPackage[];
}>;

export const AiAssistantPlanSection = (props: AiAssistantPlanSectionProps): JSX.Element => {
   const currentPlan = findCurrentPlan(props.tokenPackages);
   const tokenUsage = toTokenUsage(props.budgetSummary);

   return (
      <StyledFlex justifyContent={'space-between'} alignItems={'center'}>
         {currentPlan ? (
            <TextView testId={'currentPlan'} label={t.currentPlan}>
               <Translate>{formatCurrentPlan(currentPlan)}</Translate>
            </TextView>
         ) : null}

         <StyledFlex gap={'8px'}>
            <UsageIndicator
               testId={'tokenUsage'}
               label={
                  <Trans
                     i18nKey={tokenUsage.balance < 0 ? t.tokensUsageExceeded : t.tokensUsage}
                     values={{ usage: tokenUsage.usage, limit: tokenUsage.limit, balance: tokenUsage.balance }}
                     components={{ bold: <strong /> }}
                  />
               }
               limit={tokenUsage.limit}
               usage={tokenUsage.usage}
               width={'400px'}
            />
            <Button label={t.buyTokens} testId={'buyTokens'} onClick={openBuyTokensLink} />
         </StyledFlex>
      </StyledFlex>
   );
};
